import React, { useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";
import { useDispatch, useSelector } from "react-redux";
import { MainModal } from "../../../components/modal/MainModal";
import DataDisplay from "../../../components/dataDisplay/dataDisplay";
import Table from "../../../components/table/coreUiTable/Table";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import NoData from "../../../components/noData/noData";
import { cuFormat } from "../../../components/table/coreUiTable/Format";
import { actionCreators } from "../redux/sagas/utilization";

const addTooltip = (header, formattedValue, modalKey) => (
  <span data-tooltip-id={modalKey} data-tooltip-content={formattedValue} key={formattedValue}>
    {formattedValue}
  </span>
);

const Modal = ({ isOpen, setOpenPopup, modalKey, modalTitle }) => {
  const dispatch = useDispatch();
  const isDetailsModalLoading = useSelector((state) => state.utilization.isDetailsModalLoading);
  const modalData = useSelector((state) => state.utilization.detailsModalData[modalKey] || {});
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (Object.keys(modalData).length === 0) {
      dispatch(actionCreators.fetchModalDetailsData({ modalKey }));
    }
  }, []);

  const close = () => {
    setOpenPopup(false);
  };

  const { tableData, dataPoints = [] } = modalData;
  return (
    <MainModal
      isOpen={isOpen}
      onClose={close}
      parentSelector=".utilization-module"
      headerText={modalTitle}
      headerCloseHandler={close}
      containerClassName="utilization-details-popup-body"
      renderFooter={() => {}}
      height="auto"
      width={950}
    >
      {isDetailsModalLoading ? (
        <LoadingAnimation />
      ) : tableData?.data?.length ? (
        <>
          <div className="data-points">
            {dataPoints.length > 0 && (
              <div className="data-points">
                {dataPoints.map(({ label, value }) => (
                  <div key={label} className="data-point">
                    <DataDisplay
                      size={36}
                      value={value}
                      label={label}
                      disableAnimation
                      type="money"
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
          <Tooltip id={modalKey} float />
          <Table
            cName="utilization-details-table"
            pagination
            title=" "
            itemsPerPage={5}
            sorter
            table={tableData}
            onFilteredItemsChange={(data) => {
              setFilteredData(data);
            }}
            scopedSlots={cuFormat({
              customFn: (header, formattedValue) => addTooltip(header, formattedValue, modalKey),
              headers: tableData.colHeaders,
              columns: tableData.columns
            })}
            underTableSlot={
              <table className="table coreUiTable" id="under-table-slot">
                <tbody>
                  <tr>
                    <td style={{ fontWeight: "bold" }}>Total</td>
                    <td style={{ fontWeight: "bold" }}>{filteredData.length}</td>
                  </tr>
                </tbody>
              </table>
            }
          />
        </>
      ) : (
        <NoData />
      )}
    </MainModal>
  );
};

export const DetailsModal = ({ label }) => {
  const [isOpen, setIsOpen] = useState(false);

  const modalKey = label.toLowerCase().replace(" ", "_");

  return (
    <>
      {isOpen && (
        <Modal isOpen={isOpen} setOpenPopup={setIsOpen} modalKey={modalKey} modalTitle={label} />
      )}
      <span
        className="glyphicon glyphicon-tags"
        onClick={() => {
          setIsOpen(true);
        }}
      />
    </>
  );
};
